export enum COUPON_ADDON_POLICY_TYPE {
  ADDITIONAL_CHARGE = 1,
  VALET_PICKUP_SENDING = 2,
  LATE_NIGHT_ENTRY = 3,
  LATE_NIGHT_EXIT = 4,
  CAR_WASH = 5
}
